/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response from booking a shipment, includes conversion tracking fields
 * @export
 * @interface BookShipmentResponse
 */
export interface BookShipmentResponse {
    /**
     * Whether to fire the Google Ads First Booking conversion
     * @type {boolean}
     * @memberof BookShipmentResponse
     */
    shouldFireFirstBookingConversion: boolean;
    /**
     * Value to pass to Google Ads (5000/7000/500), only set if shouldFireFirstBookingConversion is true
     * @type {number}
     * @memberof BookShipmentResponse
     */
    firstBookingConversionValue?: number;
}

/**
 * Check if a given object implements the BookShipmentResponse interface.
 */
export function instanceOfBookShipmentResponse(value: object): value is BookShipmentResponse {
    if (!('shouldFireFirstBookingConversion' in value) || value['shouldFireFirstBookingConversion'] === undefined) return false;
    return true;
}

export function BookShipmentResponseFromJSON(json: any): BookShipmentResponse {
    return BookShipmentResponseFromJSONTyped(json, false);
}

export function BookShipmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookShipmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'shouldFireFirstBookingConversion': json['shouldFireFirstBookingConversion'],
        'firstBookingConversionValue': json['firstBookingConversionValue'] == null ? undefined : json['firstBookingConversionValue'],
    };
}

  export function BookShipmentResponseToJSON(json: any): BookShipmentResponse {
      return BookShipmentResponseToJSONTyped(json, false);
  }

  export function BookShipmentResponseToJSONTyped(value?: BookShipmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shouldFireFirstBookingConversion': value['shouldFireFirstBookingConversion'],
        'firstBookingConversionValue': value['firstBookingConversionValue'],
    };
}

